/** Column track for the payments table header and rows. */
export const PAYMENTS_GRID =
  '109px 72px 127px 75px 116px 64px 93px 63px'

export const PAYMENTS_MIN_WIDTH = 820
